import actions from './actions'

const initialState = {
  id: null,
  user: null,
  loading: false,
}

export default function surveyReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
